import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import JSZipUtils from 'jszip-utils';
import { FileTypes } from './enums';

export class FileDownloader {
  static downloadZipImages(zipName, imageUrls) {
    const zip = new JSZip();
    const folder = zip.folder(`${zipName}`);

    imageUrls.filter((url) => !!url).forEach((url) => {
      const fileName = url.split('/').at(-1);
      folder.file(`${fileName}`, this.#getBinaryContent(url), { binary: true });
    });

    folder.generateAsync({ type: 'blob' }).then((content) => saveAs(content, `${zipName}`));
  }

  static #getBinaryContent(url) {
    return new Promise((resolve, reject) => {
      JSZipUtils.getBinaryContent(url, (err, data) => {
        if (err) {
          reject(err);
        } else {
          resolve(data);
        }
      });
    });
  }

  static downloadFile(type, file, name) {
    switch (type) {
      case FileTypes.CSV:
        this.#downloadCSVFile(file, name);
        break;
    }
  }

  static #downloadCSVFile(csvFile, name) {
    const file = new File([csvFile], name, { type: 'text/csv;charset=utf-8' });
    saveAs(file);
  }

  static async downloadImageFromUrl(imageUrl) {
    const response = await fetch(imageUrl);
    const blob = await response.blob();

    const urlSegments = imageUrl.split('/');
    const fileName = urlSegments[urlSegments.length - 1];

    saveAs(blob, fileName);
  }
}
